<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    :aria-labelledby="'registrations_' + modalId"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      :class="currentStep === 1 ? 'modal-xl' : currentStep === 5 ? 'modal-lg' : 'modal-md'"
      style="height: fit-content !important"
    >
      <div class="modal-content">
        <div class="modal-header bg-spnm text-white">
          <h6 class="modal-title">
            <i class="fas fa-bell mr-2"></i>
            <span v-if="currentStep === 1">Event Registration List</span>
            <span v-if="currentStep === 2">Confirm Reminder Subject</span>
            <span v-if="currentStep === 3">Sending Reminders...</span>
            <span v-if="currentStep === 4">Reminder Results</span>
            <span v-if="currentStep === 5"><i class="fas fa-file-excel mr-1"></i>Import Offline Registrations</span>
            <span v-if="currentStep === 6"><i class="fas fa-user-plus mr-1"></i>Add Manual Registration</span>
          </h6>
          <button type="button" class="close text-white" @click="handleClose" :disabled="currentStep === 3">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Step 1: Registration List -->
        <div v-if="currentStep === 1">
          <div class="modal-body">
            <CoreDatatable
              v-if="tableData.tableHeaders != null"
              :dataBase="tableData.dataBase"
              :tableHeaders="tableData.tableHeaders"
              :title="'Registration List'"
              :dynamicTableId="dataTableID"
              @onTableReady="enableDatatableFeatures"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="handleClose">Cancel</button>
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="currentStep = 6">
              <i class="fas fa-user-plus mr-1"></i> Add Manual
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="currentStep = 5">
              <i class="fas fa-file-excel mr-1"></i> Import Offline
            </button>
            <button type="button" class="btn btn-spnm btn-sm" :disabled="mailToSend.length === 0" @click="currentStep = 2">
              <i class="fas fa-arrow-right mr-1"></i> Next ({{ mailToSend.length }} selected)
            </button>
          </div>
        </div>

        <!-- Step 5: Import Offline -->
        <div v-if="currentStep === 5">
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="mb-0 text-muted" style="font-size:0.85rem;">Upload an Excel (.xlsx) file to bulk-import offline registrations for this event.</p>
              <button class="btn btn-outline-secondary btn-sm" @click="downloadImportTemplate">
                <i class="fas fa-download mr-1"></i>Template
              </button>
            </div>
            <div class="form-group mb-2">
              <label class="font-weight-bold" style="font-size:0.85rem;">Select Excel File</label>
              <input type="file" class="form-control-file" accept=".xlsx" ref="importFile" @change="onImportFileChange" />
            </div>
            <div v-if="importResult" class="mt-2">
              <div class="alert" :class="importResult.errors.length === 0 ? 'alert-success' : 'alert-warning'" style="font-size:0.85rem;padding:8px 12px;">
                <i class="fas fa-check-circle mr-1"></i><strong>{{ importResult.saved }}</strong> records saved.
                <span v-if="importResult.errors.length > 0" class="ml-2 text-danger"><strong>{{ importResult.errors.length }}</strong> row(s) had errors.</span>
              </div>
              <div v-if="importResult.errors.length > 0" style="max-height:160px;overflow-y:auto;">
                <table class="table table-sm table-bordered">
                  <thead class="thead-light"><tr><th>Row</th><th>Reason</th></tr></thead>
                  <tbody>
                    <tr v-for="e in importResult.errors" :key="e.row" class="text-danger">
                      <td>{{ e.row }}</td><td>{{ e.reason }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="currentStep = 1; importResult = null; importFile = null">Back</button>
            <button type="button" class="btn btn-spnm btn-sm" :disabled="!importFile || importUploading" @click="uploadOfflineImport">
              <span v-if="importUploading"><i class="fas fa-spinner fa-spin mr-1"></i>Importing...</span>
              <span v-else><i class="fas fa-upload mr-1"></i>Upload &amp; Import</span>
            </button>
          </div>
        </div>

        <!-- Step 6: Add Manual Registration -->
        <div v-if="currentStep === 6">
          <div class="modal-body">
            <div v-if="manualSuccess" class="alert alert-success py-2" style="font-size:0.85rem;">
              <i class="fas fa-check-circle mr-1"></i> Registration saved. Refresh the list to see the new entry.
            </div>
            <div v-if="manualError" class="alert alert-danger py-2" style="font-size:0.85rem;">
              <i class="fas fa-exclamation-circle mr-1"></i> {{ manualError }}
            </div>
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">First Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control form-control-sm" v-model="manualForm.firstName" placeholder="First Name" />
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">Last Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control form-control-sm" v-model="manualForm.lastName" placeholder="Last Name" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">Email ID <span class="text-danger">*</span></label>
                <input type="email" class="form-control form-control-sm" v-model="manualForm.emailId" placeholder="Email" />
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">Mobile Number</label>
                <input type="text" class="form-control form-control-sm" v-model="manualForm.mobileNumber" placeholder="Mobile Number" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">Company Name</label>
                <input type="text" class="form-control form-control-sm" v-model="manualForm.companyName" placeholder="Company Name" />
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="font-weight-bold" style="font-size:0.85rem;">Membership No <span class="text-muted" style="font-weight:400;">(optional)</span></label>
                <input type="text" class="form-control form-control-sm" v-model="manualForm.membershipNo" placeholder="e.g. MEM-0001" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="currentStep = 1; manualError = null; manualSuccess = null;">Back</button>
            <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="manualSaving" @click="submitManualRegistration(true)">
              <i v-if="manualSaving" class="fas fa-spinner fa-spin mr-1"></i>
              <i v-else class="fas fa-plus mr-1"></i>Save &amp; Add Another
            </button>
            <button type="button" class="btn btn-spnm btn-sm" :disabled="manualSaving" @click="submitManualRegistration(false)">
              <span v-if="manualSaving"><i class="fas fa-spinner fa-spin mr-1"></i>Saving...</span>
              <span v-else><i class="fas fa-save mr-1"></i>Save</span>
            </button>
          </div>
        </div>

        <!-- Step 2: Confirm Subject -->
        <div v-if="currentStep === 2">
          <div class="modal-body">
            <p class="text-muted" style="font-size:0.85rem;">
              Sending reminder to <strong>{{ mailToSend.length }}</strong> registered user(s).
            </p>
            <div class="form-group">
              <label class="font-weight-bold">Email Subject</label>
              <input type="text" class="form-control form-control-sm" v-model="emailSubject" placeholder="Email subject" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="currentStep = 1">Back</button>
            <button type="button" class="btn btn-spnm btn-sm" @click="startSendReminder" :disabled="!emailSubject.trim()">
              <i class="fas fa-bell mr-1"></i> Send to {{ mailToSend.length }} user(s)
            </button>
          </div>
        </div>

        <!-- Step 3: Progress -->
        <div v-if="currentStep === 3">
          <div class="modal-body text-center py-4">
            <i class="fas fa-bell fa-2x text-primary mb-2"></i>
            <h6>Sending reminders, please wait...</h6>
            <div class="progress mb-2" style="height:22px;border-radius:11px;">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" :style="{ width: reminderProgress + '%' }">
                {{ reminderProgress }}%
              </div>
            </div>
            <div class="d-flex justify-content-between px-1" style="font-size:0.8rem;">
              <span>{{ reminderJob.processed }} / {{ reminderJob.total }} processed</span>
              <span>
                <span class="text-success font-weight-bold">{{ reminderJob.succeeded }} sent</span>
                &bull;
                <span class="text-danger font-weight-bold">{{ reminderJob.failed }} failed</span>
              </span>
            </div>
          </div>
          <div class="modal-footer"><small class="text-muted"><i class="fas fa-lock mr-1"></i>Please wait...</small></div>
        </div>

        <!-- Step 4: Results -->
        <div v-if="currentStep === 4">
          <div class="modal-body">
            <div class="d-flex justify-content-center mb-3">
              <div class="remind-badge remind-badge-success mr-3">
                <i class="fas fa-check-circle fa-2x"></i>
                <div class="font-weight-bold" style="font-size:1.3rem;">{{ reminderJob.succeeded }}</div>
                <div style="font-size:0.75rem;">Sent</div>
              </div>
              <div class="remind-badge remind-badge-danger">
                <i class="fas fa-times-circle fa-2x"></i>
                <div class="font-weight-bold" style="font-size:1.3rem;">{{ reminderJob.failed }}</div>
                <div style="font-size:0.75rem;">Failed</div>
              </div>
            </div>
            <div v-if="reminderJob.failed > 0">
              <div class="d-flex justify-content-between mb-1">
                <span class="font-weight-bold text-danger"><i class="fas fa-exclamation-triangle mr-1"></i>Failed</span>
                <button class="btn btn-outline-secondary btn-sm" @click="downloadFailed"><i class="fas fa-download mr-1"></i>CSV</button>
              </div>
              <div style="max-height:180px;overflow-y:auto;">
                <table class="table table-sm table-bordered">
                  <thead class="thead-light"><tr><th>#</th><th>Name</th><th>Email</th><th>Error</th></tr></thead>
                  <tbody>
                    <tr v-for="(e, i) in reminderJob.failedEntries" :key="i">
                      <td>{{ i+1 }}</td><td>{{ e.name }}</td><td>{{ e.email }}</td>
                      <td class="text-danger" style="font-size:0.75rem;">{{ e.error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="text-success text-center"><i class="fas fa-check-circle fa-lg mr-1"></i>All reminders sent successfully!</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-spnm btn-sm" @click="handleClose"><i class="fas fa-times mr-1"></i>Close</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CoreDatatable from "../Core/Datatable.vue";
import axios from "axios";
import $ from "jquery";

var table;
var databaseLength = 0;

export default {
  name: "EventRegistrationList",
  props: ["eventInfo", "modalId"],
  components: {
    CoreDatatable,
  },
  data() {
    return {
      mailToSend: [],
      dataTableID: "EventListTable",
      tableData: {
        dataBase: [],
        tableHeaders: null,
        title: "User Data",
      },
      currentStep: 1,
      emailSubject: "",
      reminderJob: { total: 0, processed: 0, succeeded: 0, failed: 0, failedEntries: [] },
      reminderJobId: null,
      reminderPollTimer: null,
      importFile: null,
      importUploading: false,
      importResult: null,
      manualForm: { firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", membershipNo: "" },
      manualSaving: false,
      manualError: null,
      manualSuccess: null,
    };
  },
  computed: {
    reminderProgress() {
      if (!this.reminderJob.total) return 0;
      return Math.round((this.reminderJob.processed / this.reminderJob.total) * 100);
    },
  },
  created() {
    this.getRegistrationList();
    this.dataTableID = "EventListTable" + this.eventInfo.eventId;
    this.emailSubject = "Reminder: " + (this.eventInfo.title || "SPNM Event");
  },
  mounted() {},
  methods: {
    getRegistrationList() {
      var requestBody = { eventId: this.eventInfo.eventId };
      var _this = this;
      axios
        .post("/api/EventRegistration/GetEventRegistrationsList", requestBody)
        .then(function (response) {
          databaseLength = response.data.length;
          _this.generateTable(response.data);
        })
        .catch(function (error) {
          if (error.response) { console.log(error.response); } else { console.log(error); }
        });
    },

    generateTable(dataBase) {
      var tableHeaders = [
        {
          title: '<input type="checkbox" class=" mt-0 ml-0 er-select-all" id="erSelectAll"> ',
          data: "userId",
          className: "dt-left",
          orderable: false,
          render: function () {
            return '<input type="checkbox" class="form-check-input ml-1 er-select-checkBox" id="erSelectCheckbox">';
          },
        },
        { title: "Membership No.", data: "membershipNo", className: "dt-left" },
        { title: "Acknowledgement No.", data: "acknowledgementNumber", className: "dt-left" },
        { title: "First Name", className: "dt-left", data: "firstName" },
        { title: "Last Name", className: "dt-left", data: "lastName" },
        { title: "Company Name", className: "dt-left", data: "companyName" },
        { title: "Mail ID", className: "dt-left", data: "emailId" },
        { title: "Contact Number", className: "dt-left", data: "mobileNumber" },
        {
          title: "Source",
          data: "source",
          className: "text-center dt-center",
          orderable: false,
          render: function (data) {
            if (data === "OFFLINE")
              return '<span class="badge badge-warning">Offline</span>';
            return '<span class="badge badge-success">Online</span>';
          },
        },
        {
          title: "Attendence",
          data: "attended",
          className: "text-center dt-center",
          orderable: false,
          render: function (data, type) {
            if (type === "display") {
              return '<input type="checkbox" class="form-check-input ml-1 mark-attendence" id="markAttendence">';
            }
            return data;
          },
        },
      ];
      this.tableData.dataBase = dataBase;
      this.tableData.tableHeaders = tableHeaders;
    },

    enableDatatableFeatures() {
      table = $("#dashboardTable" + this.dataTableID).DataTable();
      var _this = this;

      $("#dashboardTable" + this.dataTableID + " tbody").on("click", "input.mark-attendence", function () {
        var rowdata = table.row($(this).parents("tr")).data();
        _this.markAttendence(rowdata);
      });

      $("#dashboardTable" + this.dataTableID + " tbody").on("click", "input.er-select-checkBox", function () {
        var rowdata = table.row($(this).parents("tr")).data();
        let obj = _this.mailToSend.find((o) => o.userId === rowdata.userId);
        if (obj) {
          _this.mailToSend.splice(_this.mailToSend.findIndex((a) => a.userId === rowdata.userId), 1);
        } else {
          _this.mailToSend.push(rowdata);
        }
        if (_this.mailToSend.length == databaseLength) {
          _this.mailToSend = _this.tableData.dataBase;
          $(".er-select-all").prop("checked", true);
        } else {
          $(".er-select-all").prop("checked", false);
        }
      });

      $("#dashboardTable" + this.dataTableID + " thead").on("click", "input.er-select-all", function () {
        if (_this.mailToSend.length != parseInt(_this.tableData.dataBase.length)) {
          _this.mailToSend = _this.tableData.dataBase;
          $(".er-select-checkBox").prop("checked", true);
        } else {
          _this.mailToSend = [];
          $(".er-select-checkBox").prop("checked", false);
        }
      });
    },

    markAttendence(registrationData) {
      registrationData.attended = registrationData.attended === "N" ? "Y" : "N";
      var _this = this;
      axios
        .post("/api/EventRegistration/MarkAttendence", registrationData)
        .then(function () { alert("Attendence Updated."); })
        .catch(function (error) {
          if (error.response) { console.log(error.response); } else { console.log(error); }
        });
    },

    startSendReminder() {
      this.currentStep = 3;
      this.reminderJob = { total: this.mailToSend.length, processed: 0, succeeded: 0, failed: 0, failedEntries: [] };
      var _this = this;
      axios
        .post("/api/Event/RemindForEvent", {
          eventId: this.eventInfo.eventId,
          EventRegistrationList: this.mailToSend,
          Subject: this.emailSubject,
        })
        .then(function (response) {
          _this.reminderJobId = response.data.jobId;
          _this.reminderPollTimer = setInterval(_this.pollReminderProgress, 2000);
        })
        .catch(function (error) {
          _this.currentStep = 2;
          alert("Failed to start: " + (error.response ? error.response.data : error.message));
        });
    },

    pollReminderProgress() {
      var _this = this;
      axios
        .get("/api/BulkMail/Progress/" + this.reminderJobId)
        .then(function (response) {
          var d = response.data;
          _this.reminderJob = { total: d.total, processed: d.processed, succeeded: d.succeeded, failed: d.failed, failedEntries: d.failedEntries || [] };
          if (d.status === "completed" || d.status === "failed") {
            clearInterval(_this.reminderPollTimer);
            _this.reminderPollTimer = null;
            _this.currentStep = 4;
          }
        })
        .catch(function () {
          clearInterval(_this.reminderPollTimer);
          _this.reminderPollTimer = null;
          _this.currentStep = 4;
        });
    },

    handleClose() {
      if (this.currentStep === 3) return;
      this.currentStep = 1;
      this.mailToSend = [];
      this.reminderJobId = null;
      this.reminderJob = { total: 0, processed: 0, succeeded: 0, failed: 0, failedEntries: [] };
      this.emailSubject = "Reminder: " + (this.eventInfo.title || "SPNM Event");
      if (this.reminderPollTimer) { clearInterval(this.reminderPollTimer); this.reminderPollTimer = null; }
      $("#" + this.modalId).modal("hide");
    },

    downloadFailed() {
      const rows = [["Name", "Email", "Error"]].concat(
        this.reminderJob.failedEntries.map(e => [e.name, e.email, e.error])
      );
      const csv = rows.map(r => r.map(c => '"' + String(c).replace(/"/g, '""') + '"').join(",")).join("\n");
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
      a.download = "reminder_failed.csv";
      a.click();
    },

    downloadImportTemplate() {
      const headers = "FirstName,LastName,MembershipNo,EmailId,MobileNumber,CompanyName";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([headers], { type: "text/csv" }));
      a.download = "offline_registration_template.csv";
      a.click();
    },

    onImportFileChange(e) {
      this.importFile = e.target.files[0] || null;
      this.importResult = null;
    },

    uploadOfflineImport() {
      if (!this.importFile) return;
      this.importUploading = true;
      this.importResult = null;
      var _this = this;
      const form = new FormData();
      form.append("file", this.importFile);
      form.append("eventId", this.eventInfo.eventId);
      axios
        .post("/api/EventRegistration/ImportOffline", form, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
          _this.importResult = response.data;
          _this.importUploading = false;
          if (response.data.saved > 0) {
            _this.getRegistrationList();
          }
        })
        .catch(function (error) {
          _this.importUploading = false;
          _this.importResult = { saved: 0, errors: [{ row: 0, reason: error.response ? error.response.data : error.message }] };
        });
    },

    submitManualRegistration(keepOpen) {
      this.manualError = null;
      this.manualSuccess = null;
      const f = this.manualForm;
      if (!f.firstName.trim()) { this.manualError = "First Name is required."; return; }
      if (!f.lastName.trim())  { this.manualError = "Last Name is required."; return; }
      if (!f.emailId.trim())   { this.manualError = "Email ID is required."; return; }
      this.manualSaving = true;
      var _this = this;
      axios
        .post("/api/EventRegistration/AddManualRegistration", {
          eventId:      this.eventInfo.eventId,
          firstName:    f.firstName.trim(),
          lastName:     f.lastName.trim(),
          emailId:      f.emailId.trim(),
          mobileNumber: f.mobileNumber.trim(),
          companyName:  f.companyName.trim(),
          membershipNo: f.membershipNo.trim(),
        })
        .then(function () {
          _this.manualSaving = false;
          _this.getRegistrationList();
          _this.manualForm = { firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", membershipNo: "" };
          if (keepOpen) {
            _this.manualSuccess = true;
          } else {
            _this.currentStep = 1;
            _this.manualSuccess = null;
          }
        })
        .catch(function (error) {
          _this.manualSaving = false;
          var msg = error.response ? error.response.data : error.message;
          _this.manualError = Array.isArray(msg) ? msg.join(" ") : String(msg);
        });
    },
  },
};
</script>

<style scoped>
.remind-badge {
  display: flex; flex-direction: column; align-items: center;
  padding: 12px 24px; border-radius: 10px;
}
.remind-badge-success { background: #d4edda; color: #155724; }
.remind-badge-danger  { background: #f8d7da; color: #721c24; }
</style>
